// Temporary compatibility layer until everything is moved to the SPA.
//
// These hand a constructor to Blade pages that still run their own script:
// products/show.blade.php builds a sales rank chart and settings/index.blade.php
// builds the rich text editors.
//
// Take the default export off the namespace. A dynamic import() resolves to the
// module namespace object, not to what the module exports, so assigning the
// result directly gave window.Chart a namespace and every `new Chart(...)` threw
// "Chart is not a constructor". Both pages failed silently: the rejection
// happened inside the promise these functions return, so nothing surfaced to the
// user beyond a graph and a set of editors that never appeared.

window.loadChartJS = async function() {
    window.Chart = (await import(/* webpackChunkName: 'chartjs' */ 'chart.js')).default;
}

window.loadQuill = async function() {
    window.Quill = (await import(/* webpackChunkName: 'quill' */ 'quill')).default;
}
